import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const steps = [
  {
    num: '01',
    icon: 'ri-user-add-line',
    title: 'Регистрируетесь как партнёр',
    desc: 'Пишете нам в Telegram, получаете персональную партнёрскую ссылку и доступ к материалам.',
  },
  {
    num: '02',
    icon: 'ri-share-forward-line',
    title: 'Приводите клиентов',
    desc: 'Делитесь ссылкой с бизнес-сообществом, в соцсетях, на конференциях. Клиент переходит и оформляет заказ.',
  },
  {
    num: '03',
    icon: 'ri-bank-card-line',
    title: 'Получаете комиссию',
    desc: 'Как только клиент оплачивает — вы получаете свой процент. Выплаты приходят сразу, без задержек и минимальных порогов.',
  },
];

export default function PartnerHowWorks() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: stepsRef, revealedCount: stepsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Как это работает
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Три шага до вашего первого партнёрского дохода
          </h2>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="hidden md:block absolute left-8 top-16 bottom-16 w-[2px] bg-gradient-to-b from-primary-200 via-primary-300 to-primary-200"></div>

          <div ref={stepsRef} className="flex flex-col gap-8">
            {steps.map((step, i) => (
              <div
                key={step.num}
                className={`relative flex flex-col md:flex-row gap-5 md:gap-8 items-start reveal-fade-up ${i < stepsRevealed ? 'revealed' : ''}`}
                style={i < stepsRevealed ? { transitionDelay: `${i * 150}ms` } : undefined}
              >
                <div className="relative z-10 w-16 h-16 rounded-2xl bg-primary-100 border border-primary-200/60 flex items-center justify-center shrink-0">
                  <span className="font-display font-bold text-primary-700 text-lg">{step.num}</span>
                </div>

                <div className="flex-1 bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-7 hover:border-primary-500/30 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                      <i className={`${step.icon} text-accent-600 text-base`}></i>
                    </div>
                    <h3 className="font-display font-bold text-[18px] md:text-[20px] text-foreground-950">{step.title}</h3>
                  </div>
                  <p className="text-[14.5px] md:text-[15px] text-foreground-500 leading-relaxed pl-0 md:pl-12">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}